module.exports = __webpack_public_path__ + "img/Passata180_ok.9e67c602.png";